<template>
    <div class="advertising-wrapper">
      <v-toolbar>
        <v-tabs align-with-title light>
          <v-tabs-slider color="blue"></v-tabs-slider>

          <v-tab
            v-for="(tab, i) in tabs"
            :key="`tab-${i}`"
            @click="$router.push({ name: tab.link })"
          >
            {{ tab.title }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-container>
        <router-view keep-alive />
      </v-container>
    </div>
</template>

<script>
export default {
  name: "Insights",
  data() {
    return {
      selectedTab: null,
      tabs: [
        {
          title: "Trends over time",
          link: "InsightsGDSTrendsOverTime",
        },
        { title: "Weekly detail", link: "InsightsGDSWeeklyDetail" },
      ],
    };
  },
};
</script>
